import { Link } from "react-router-dom";

export default function NodataFound() {
  return (
    <div className="page-navbar-space container">
      <div className="d-flex align-items-center justify-content-center flex-column">
        <img src="/Assets/Img/404.png" alt="404" className="img-fluid" />
        <h1 className="display-1 fw-bold text-warning text-center">No Data Found</h1>
        <p className="lead text-muted text-center fw-medium">Sorry, we couldn't find any data at the moment. Please try again later.</p>
        <Link to="/" className="btn btn-primary  btn-lg mt-4">
          Go Home
        </Link>
      </div>
    </div>
  )
}
